import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
    // Login
    {
        path: '/',
        name: 'login',
        component: () => import('@/views/Login'),
    },
    {
        path: '/assistance',
        name: 'assistance',
        component: () => import('@/views/Assistance'),
    },
    {
        path: '/reset/:code',
        name: 'reset',
        props: true,
        component: () => import('@/views/Reset'),
    },
    {
        path: '/wiaa-help',
        name: 'wiaahelp',
        component: () => import('@/views/info/WiaaHelp'),
    },
    {
        path: '/login',
        redirect: '/'
    },
    {
        path: '/signup',
        name: 'signup',
        component: () => import('@/views/Signup'),
    },
    {
        path: '/signout',
        beforeEnter(to, from, next) {
            store.dispatch('signOut');
            next('/');
        }
    },
    {
        path: '/suspended',
        name: 'suspended',
        component: () => import('@/views/Suspended'),
    },
    {
        path: '/taxes-owed',
        name: 'taxes-owed',
        component: () => import('@/views/TaxesOwed'),
    },

    // Quick Access
    {
        path: '/register/:code', // conference
        name: 'register-conference',
        props: true,
        component: () => import('@/views/conferences/Preview'),
    },


    // Account
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {section: 'dashboard'},
        component: () => import('@/views/dashboard/Dashboard'),
    },

    // Conf registrations
    {
        path: '/registrations',
        name: 'registrations',
        meta: {section: 'conferences'},
        component: () => import('@/views/registrations/Registrations'),
    },
    {
        path: '/conference/:registrationId',
        component: () => import('@/views/registrations/Conference'),
        name: 'conference',
        meta: {section: 'conferences'},
        redirect: {name: 'conf-information'},
        props: true,
        children: [
            {
                path: 'information',
                name: 'conf-information',
                props: true,
                component: () => import('@/views/registrations/Information'),
            },
            {
                path: 'schedule',
                name: 'schedule',
                props: true,
                component: () => import('@/views/registrations/Schedule'),
            },
            {
                path: 'on-demand',
                redirect: '/on-demand/sessions',
                component: () => import('@/views/registrations/on_demand/OnDemand'),
                props: true,
                children: [
                    {
                        path: '',
                        name: 'on-demand',
                        props: true,
                        component: () => import('@/views/registrations/on_demand/Sessions'),
                    },
                    {
                        path: ':sessionId',
                        name: 'on-demand-content',
                        props: true,
                        component: () => import('@/views/registrations/on_demand/Content'),
                    }
                ]
            },
            {
                path: 'log',
                name: 'record-log',
                props: true,
                component: () => import('@/views/registrations/RecordLog'),
            },
            {
                path: 'applications',
                redirect: '/applications/list',
                component: () => import('@/views/registrations/applications/Applications'),
                props: true,
                children: [
                    {
                        path: 'list',
                        name: 'conf-applications',
                        props: true,
                        component: () => import('@/views/registrations/applications/List'),
                    },
                    {
                        path: ':applicationId',
                        name: 'application',
                        props: true,
                        component: () => import('@/views/registrations/applications/Application'),
                    }
                ]
            },
            {
                path: 'registration',
                name: 'registration',
                props: true,
                component: () => import('@/views/registrations/Registration'),
            },
            {
                path: 'PO',
                name: 'po-request',
                props: true,
                component: () => import('@/views/registrations/PO'),
            },
        ]
    },
    {
        path: '/invoice/:registrationId/:code',
        name: 'invoice',
        meta: {section: 'conferences'},
        props: true,
        component: () => import('@/views/registrations/Invoice'),
    },

    // Course enrollments
    {
        path: '/enrollments/:view?', // '' | completed
        name: 'enrollments',
        props: true,
        meta: {section: 'courses'},
        component: () => import('@/views/enrollments/Enrollments')
    },
    {
        path: '/course/:enrollmentId',
        name: 'course-container',
        meta: {section: 'courses'},
        component: () => import('@/views/enrollments/Container'),
        redirect: {name: 'course-welcome'},
        props: true,
        children: [
            {
                path: 'information',
                name: 'course',
                component: () => import('@/views/enrollments/Course'),
                redirect: {name: 'course-welcome'},
                props: true,
                children: [
                    {
                        path: 'intro',
                        name: 'course-welcome',
                        props: true,
                        component: () => import('@/views/enrollments/Welcome'),
                    },
                    {
                        path: 'setup',
                        name: 'course-setup',
                        props: true,
                        component: () => import('@/views/enrollments/Setup'),
                    },
                    {
                        path: 'notes',
                        name: 'enroll-notes',
                        props: true,
                        component: () => import('@/views/enrollments/Notes'),
                    },
                    {
                        path: 'files',
                        name: 'enroll-files',
                        props: true,
                        component: () => import('@/views/enrollments/Files'),
                    },
                    {
                        path: 'reflections',
                        name: 'enroll-reflections',
                        props: true,
                        component: () => import('@/views/enrollments/Reflections'),
                    },
                    {
                        path: 'log',
                        name: 'study-log',
                        props: true,
                        component: () => import('@/views/enrollments/StudyLog'),
                    },
                    // "Your Enrollment" (the course counterpart of the
                    // conference "Your Registration" page) + Reallocate Hours
                    {
                        path: 'enrollment',
                        name: 'course-enrollment',
                        props: true,
                        component: () => import('@/views/enrollments/YourEnrollment'),
                    },
                    {
                        path: 'reallocate',
                        name: 'course-reallocate',
                        props: true,
                        component: () => import('@/views/enrollments/ReallocateHours'),
                    },
                    {
                        path: 'applications',
                        redirect: '/applications/list',
                        component: () => import('@/views/enrollments/applications/Applications'),
                        props: true,
                        children: [
                            {
                                path: 'list',
                                name: 'course-applications',
                                props: true,
                                component: () => import('@/views/enrollments/applications/List'),
                            },
                            {
                                path: ':applicationId',
                                name: 'course-application',
                                props: true,
                                component: () => import('@/views/enrollments/applications/Application'),
                            }
                        ]
                    },
                ]
            },
            {
                path: 'outline',
                name: 'course-outline',
                component: () => import('@/views/enrollments/Outline'),
                props: true,
                children: [
                    {
                        path: 'component/:outlineId',
                        name: 'component',
                        component: () => import('@/views/enrollments/View'),
                        props: true
                    },
                    {
                        path: 'overview/:sectionId',
                        name: 'overview',
                        component: () => import('@/views/enrollments/Overview'),
                        props: true
                    },
                ]
            },

        ]
    },

    // old course (new_course=1, uses course_outline table)
    {
        path: '/legacy/:enrollmentId',
        name: 'legacy',
        meta: {section: 'courses'},
        component: () => import('@/views/enrollments/Legacy'),
        props: true,
        children: [
            {
                path: ':outlineId',
                name: 'legacy-component',
                component: () => import('@/views/enrollments/LegacyView'),
                props: true
            },
        ]
    },
    {
        path: '/course-catalog',
        name: 'course-catalog',
        meta: {section: 'courses'},
        component: () => import('@/views/courses/CourseCatalog'),
    },
    {
        path: '/course-catalog/bundle',
        name: 'package-builder',
        meta: {section: 'courses'},
        component: () => import('@/views/courses/PackageBuilder'),
    },
    {
        path: '/course-catalog/enroll/:courseId',
        name: 'course-enroll',
        meta: {section: 'courses'},
        props: true,
        component: () => import('@/views/courses/CourseEnroll'),
    },
    {
        path: '/cart-checkout',
        name: 'cart-checkout',
        meta: {section: 'courses'},
        component: () => import('@/views/courses/CartCheckout'),
    },
    {
        path: '/reactivation',
        name: 'reactivation-checkout',
        meta: {section: 'courses'},
        component: () => import('@/views/courses/ReactivationCheckout'),
    },
    {
        path: '/conference-center',
        meta: {section: 'conferences'},
        component: () => import('@/views/conferences/ConferenceCenter'),
        children: [
            {
                path: '',
                name: 'conference-center',
                component: () => import('@/views/conferences/Beta'),
            },
            {
                path: 'register/:confId',
                name: 'register',
                component: () => import('@/views/conferences/Register'),
                props: true,
            }
        ]
    },
    {
        path: '/activity',
        name: 'study-activity',
        meta: {section: 'records'},
        component: () => import('@/views/activity/StudyActivity'),
    },
    {
        path: '/professional-development/:view?', // '' overview | salary | renewal | settings
        name: 'pd',
        props: true,
        meta: {section: 'pd'},
        component: () => import('@/views/pd/ProfessionalDevelopment'),
    },
    {
        path: '/reports/:view?', // '' (lands on the best view) | applications | completed | receipts
        name: 'reports',
        props: true,
        meta: {section: 'records'},
        component: () => import('@/views/reports/Reports'),
    },
    {
        // Account settings sections are routable: /account/billing, /account/pd ...
        path: '/account/:section?',
        name: 'account',
        props: true,
        meta: {section: 'account'},
        component: () => import('@/views/account/Account'),
    },
    {
        path: '/support/:view?', // '' tickets | new
        name: 'support',
        props: true,
        meta: {section: 'support'},
        component: () => import('@/views/support/Support'),
    },


    // Providers
    {
        path: '/providers/portal/login',
        name: 'portalLogin',
        component: () => import('@/views/providers/portal/Login'),
    },
    {
        path: '/providers/finalforms/login',
        name: 'ffLogin',
        component: () => import('@/views/providers/finalforms/Login'),
    },
    {
        path: '/providers/finalforms/certification/:id',
        name: 'ffCertification',
        props: true,
        component: () => import('@/views/providers/finalforms/Certification'),

    }
];

const router = new VueRouter({
    mode: 'hash',
    routes
});

const publicRoutes = ['/', '/login', '/signup', '/assistance', '/suspended', '/taxes-owed', '/signout', '/wiaa-help'];

export function isPublicPath(path) {
    return publicRoutes.includes(path) || path.startsWith('/reset/') || path.startsWith('/register/') || path.startsWith('/providers/');
}

router.beforeEach((to, from, next) => {
    const user = store.getters.currentUser;
    const isPublic = isPublicPath(to.path);

    // Legacy account deep links used ?section=billing; fold them into the
    // /account/:section param. Done here (not beforeEnter) so it also applies
    // when already on the account route.
    if (to.name === 'account' && !to.params.section && typeof to.query.section === 'string' && to.query.section) {
        const query = {...to.query};
        delete query.section;
        return next({name: 'account', params: {section: to.query.section}, query, replace: true});
    }

    // Your Account > Professional Development moved to its own section
    if (to.name === 'account' && to.params.section === 'pd') {
        return next({name: 'pd', replace: true});
    }

    if (user && user.suspension_message && to.path !== '/suspended' && !isPublic) {
        next('/suspended');
    } else if (user && user.owes_sales_tax && to.path !== '/taxes-owed' && !isPublic) {
        next('/taxes-owed');
    } else {
        next();
    }
});

export default router;
